module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Design/Eraser-f665dd9e331fad7f1e0070976dde49f58d81161f776d226f32d21907532a37c9.svg";